import { Avatar, Grid2 as Grid, Stack, Typography, Link } from "@mui/material"
import { Allegato } from "../types"
import { useTranslation } from "react-i18next"
import { AttachmentOutlined } from "@mui/icons-material"

export default function AllegatiGrid({ allegati_data }: { allegati_data: Allegato[] }) {
  const { t } = useTranslation()
  return (
    <>
      <Grid container spacing={2}>
        {allegati_data?.map((a) => (
          <Grid size={8} key={a.id}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Avatar
                variant="rounded"
              >
                <AttachmentOutlined />
              </Avatar>
              <Stack>
                <Link href={a.attachment} target="_blank" color="text.primary" download>
                  <Typography variant="body1">{a.nome_originale || a.nome}</Typography>
                </Link>
                <Typography variant="body2" color="text.secondary">
                  {a.note}
                </Typography>
              </Stack>
            </Stack>
          </Grid>
        ))}
      </Grid>
      {allegati_data?.length === 0 && (
        <Typography variant="body1" color="text.secondary">
          {t("general.senza_allegati")}
        </Typography>
      )}
    </>
  )
}
